// JOH World — API-laag (run-validatie + leaderboard via de JOH Boxing backend).
const BASE = process.env.REACT_APP_BACKEND_URL;

async function post(path, body) {
  const r = await fetch(`${BASE}/api/joh-world${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    let msg = `HTTP ${r.status}`;
    try { msg = (await r.json()).detail || msg; } catch { /* ignore */ }
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return r.json();
}

export async function startRun(assisted = false) {
  return post("/run/start", { assisted });
}

export async function sendProgress(runId, event, data = {}) {
  return post("/run/progress", { run_id: runId, event, data });
}

export async function completeRun(runId, payload) {
  return post("/run/complete", { run_id: runId, ...payload });
}

export async function fetchLeaderboard(limit = 3) {
  const r = await fetch(`${BASE}/api/joh-world/leaderboard?limit=${limit}`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}
